/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAppUser = /* GraphQL */ `
  query GetAppUser($id: ID!) {
    getAppUser(id: $id) {
      id
      profile
      username
      authUsername
      authUserID
      type
      icon
      isEnabled
      createdAt
      updatedAt
      groupID
      group {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      farms {
        nextToken
        startedAt
      }
      photos {
        nextToken
        startedAt
      }
      messages {
        nextToken
        startedAt
      }
      conversations {
        nextToken
        startedAt
      }
      sendPictures {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listAppUsers = /* GraphQL */ `
  query ListAppUsers(
    $filter: ModelAppUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncAppUsers = /* GraphQL */ `
  query SyncAppUsers(
    $filter: ModelAppUserFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncAppUsers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getUserGroup = /* GraphQL */ `
  query GetUserGroup($id: ID!) {
    getUserGroup(id: $id) {
      id
      users {
        nextToken
        startedAt
      }
      groupName
      groupType
      icon
      createdAt
      updatedAt
      farms {
        nextToken
        startedAt
      }
      groupConversations {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listUserGroups = /* GraphQL */ `
  query ListUserGroups(
    $filter: ModelUserGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncUserGroups = /* GraphQL */ `
  query SyncUserGroups(
    $filter: ModelUserGroupFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserGroups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getCooperation = /* GraphQL */ `
  query GetCooperation($id: ID!) {
    getCooperation(id: $id) {
      groupID
      cooperationGroupID
      createdAt
      updatedAt
      id
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listCooperation = /* GraphQL */ `
  query ListCooperation(
    $filter: ModelCooperationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCooperation(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        groupID
        cooperationGroupID
        createdAt
        updatedAt
        id
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncCooperation = /* GraphQL */ `
  query SyncCooperation(
    $filter: ModelCooperationFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCooperation(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        groupID
        cooperationGroupID
        createdAt
        updatedAt
        id
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getFriendship = /* GraphQL */ `
  query GetFriendship($id: ID!) {
    getFriendship(id: $id) {
      userID
      friendID
      createdAt
      updatedAt
      id
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listFriendships = /* GraphQL */ `
  query ListFriendships(
    $filter: ModelFriendshipFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFriendships(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        userID
        friendID
        createdAt
        updatedAt
        id
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncFriendships = /* GraphQL */ `
  query SyncFriendships(
    $filter: ModelFriendshipFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncFriendships(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        userID
        friendID
        createdAt
        updatedAt
        id
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getFarm = /* GraphQL */ `
  query GetFarm($id: ID!) {
    getFarm(id: $id) {
      id
      userID
      user {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      groupID
      group {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      name
      lat
      lng
      memo
      createdAt
      updatedAt
      varieties
      photos {
        nextToken
        startedAt
      }
      dayDiagnoses {
        nextToken
        startedAt
      }
      dailyLogs {
        nextToken
        startedAt
      }
      monthReports {
        nextToken
        startedAt
      }
      cultivationEvents {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listFarms = /* GraphQL */ `
  query ListFarms(
    $filter: ModelFarmFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFarms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncFarms = /* GraphQL */ `
  query SyncFarms(
    $filter: ModelFarmFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncFarms(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listFarmsByUser = /* GraphQL */ `
  query ListFarmsByUser(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFarmFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFarmsByUser(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listFarmsByGroup = /* GraphQL */ `
  query ListFarmsByGroup(
    $groupID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelFarmFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFarmsByGroup(
      groupID: $groupID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getPhoto = /* GraphQL */ `
  query GetPhoto($id: ID!) {
    getPhoto(id: $id) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      userID
      user {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      photoKey
      takenAt
      lat
      lng
      depthsKey
      createdAt
      updatedAt
      diagnoses {
        nextToken
        startedAt
      }
      comments {
        nextToken
        startedAt
      }
      dayDiagnosisID
      dayDiagnosis {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      diagnoseTypes
      distanceToPearShelf
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listPhotos = /* GraphQL */ `
  query ListPhotos(
    $filter: ModelPhotoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPhotos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncPhotos = /* GraphQL */ `
  query SyncPhotos(
    $filter: ModelPhotoFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPhotos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listPhotosByFarm = /* GraphQL */ `
  query ListPhotosByFarm(
    $farmID: ID!
    $takenAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPhotoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPhotosByFarm(
      farmID: $farmID
      takenAt: $takenAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listPhotosByUser = /* GraphQL */ `
  query ListPhotosByUser(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPhotoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPhotosByUser(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listPhotosByKey = /* GraphQL */ `
  query ListPhotosByKey(
    $photoKey: String!
    $takenAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPhotoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPhotosByKey(
      photoKey: $photoKey
      takenAt: $takenAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listPhotosByDayDiagnosis = /* GraphQL */ `
  query ListPhotosByDayDiagnosis(
    $dayDiagnosisID: ID!
    $takenAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPhotoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPhotosByDayDiagnosis(
      dayDiagnosisID: $dayDiagnosisID
      takenAt: $takenAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getDiagnosis = /* GraphQL */ `
  query GetDiagnosis($id: ID!) {
    getDiagnosis(id: $id) {
      id
      photoID
      photo {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      diagnoseType
      diagnoseResult
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listDiagnoses = /* GraphQL */ `
  query ListDiagnoses(
    $filter: ModelDiagnosisFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDiagnoses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        photoID
        diagnoseType
        diagnoseResult
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncDiagnoses = /* GraphQL */ `
  query SyncDiagnoses(
    $filter: ModelDiagnosisFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDiagnoses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        photoID
        diagnoseType
        diagnoseResult
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listDiagnosesByPhotoID = /* GraphQL */ `
  query ListDiagnosesByPhotoID(
    $photoID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDiagnosisFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDiagnosesByPhotoID(
      photoID: $photoID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        photoID
        diagnoseType
        diagnoseResult
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getDayDiagnosis = /* GraphQL */ `
  query GetDayDiagnosis($id: ID!) {
    getDayDiagnosis(id: $id) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      date
      isAggregated
      photos {
        nextToken
        startedAt
      }
      comments {
        nextToken
        startedAt
      }
      diagnosisSummaries {
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listDayDiagnoses = /* GraphQL */ `
  query ListDayDiagnoses(
    $filter: ModelDayDiagnosisFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDayDiagnoses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncDayDiagnoses = /* GraphQL */ `
  query SyncDayDiagnoses(
    $filter: ModelDayDiagnosisFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDayDiagnoses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listDayDianosesByFarm = /* GraphQL */ `
  query ListDayDianosesByFarm(
    $farmID: ID!
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDayDiagnosisFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDayDianosesByFarm(
      farmID: $farmID
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getDiagnosisSummary = /* GraphQL */ `
  query GetDiagnosisSummary($id: ID!) {
    getDiagnosisSummary(id: $id) {
      id
      dayDiagnosisID
      dayDiagnosis {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      diagnoseType
      diagnoseResult
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listDiagnosisSummaries = /* GraphQL */ `
  query ListDiagnosisSummaries(
    $filter: ModelDiagnosisSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDiagnosisSummaries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dayDiagnosisID
        diagnoseType
        diagnoseResult
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncDiagnosisSummaries = /* GraphQL */ `
  query SyncDiagnosisSummaries(
    $filter: ModelDiagnosisSummaryFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDiagnosisSummaries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        dayDiagnosisID
        diagnoseType
        diagnoseResult
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listDiagnosisSummariesByDayDiagnosis = /* GraphQL */ `
  query ListDiagnosisSummariesByDayDiagnosis(
    $dayDiagnosisID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDiagnosisSummaryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDiagnosisSummariesByDayDiagnosis(
      dayDiagnosisID: $dayDiagnosisID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dayDiagnosisID
        diagnoseType
        diagnoseResult
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getPhotoComment = /* GraphQL */ `
  query GetPhotoComment($id: ID!) {
    getPhotoComment(id: $id) {
      id
      photoID
      photo {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      authorID
      text
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listPhotoComments = /* GraphQL */ `
  query ListPhotoComments(
    $filter: ModelPhotoCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPhotoComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        photoID
        authorID
        text
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncPhotoComments = /* GraphQL */ `
  query SyncPhotoComments(
    $filter: ModelPhotoCommentFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncPhotoComments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        photoID
        authorID
        text
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listPhotoCommentsByPhoto = /* GraphQL */ `
  query ListPhotoCommentsByPhoto(
    $photoID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPhotoCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPhotoCommentsByPhoto(
      photoID: $photoID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        photoID
        authorID
        text
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getDayDiagnoseComment = /* GraphQL */ `
  query GetDayDiagnoseComment($id: ID!) {
    getDayDiagnoseComment(id: $id) {
      id
      dayDiagnosisID
      dayDiagnosis {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      authorID
      text
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listDayDiagnoseComments = /* GraphQL */ `
  query ListDayDiagnoseComments(
    $filter: ModelDayDiagnoseCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDayDiagnoseComments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dayDiagnosisID
        authorID
        text
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncDayDiagnoseComments = /* GraphQL */ `
  query SyncDayDiagnoseComments(
    $filter: ModelDayDiagnoseCommentFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDayDiagnoseComments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        dayDiagnosisID
        authorID
        text
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listDayDiagnoseCommentsByDayDiagnosis = /* GraphQL */ `
  query ListDayDiagnoseCommentsByDayDiagnosis(
    $dayDiagnosisID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDayDiagnoseCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDayDiagnoseCommentsByDayDiagnosis(
      dayDiagnosisID: $dayDiagnosisID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dayDiagnosisID
        authorID
        text
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getDailyLog = /* GraphQL */ `
  query GetDailyLog($id: ID!) {
    getDailyLog(id: $id) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      monthReportID
      monthReport {
        id
        farmID
        yearMonth
        totalWorkingTime
        pesticideSprayningTime
        matingWorkTime
        harvestingTime
        fruitsThinningTime
        othersTime
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      category
      categoryOptional
      date
      workingTime
      workMemo
      varieties
      authorID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listDailyLogs = /* GraphQL */ `
  query ListDailyLogs(
    $filter: ModelDailyLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDailyLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        farmID
        monthReportID
        category
        categoryOptional
        date
        workingTime
        workMemo
        varieties
        authorID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncDailyLogs = /* GraphQL */ `
  query SyncDailyLogs(
    $filter: ModelDailyLogFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncDailyLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        farmID
        monthReportID
        category
        categoryOptional
        date
        workingTime
        workMemo
        varieties
        authorID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listDailyLogsByFarm = /* GraphQL */ `
  query ListDailyLogsByFarm(
    $farmID: ID!
    $dateCategory: ModelDailyLogDailyLogByFarmCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDailyLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDailyLogsByFarm(
      farmID: $farmID
      dateCategory: $dateCategory
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        farmID
        monthReportID
        category
        categoryOptional
        date
        workingTime
        workMemo
        varieties
        authorID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listDailyLogsByMonthReport = /* GraphQL */ `
  query ListDailyLogsByMonthReport(
    $monthReportID: ID!
    $dateCategory: ModelDailyLogDailyLogByMonthReportCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDailyLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDailyLogsByMonthReport(
      monthReportID: $monthReportID
      dateCategory: $dateCategory
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        farmID
        monthReportID
        category
        categoryOptional
        date
        workingTime
        workMemo
        varieties
        authorID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getCultivationEvent = /* GraphQL */ `
  query GetCultivationEvent($id: ID!) {
    getCultivationEvent(id: $id) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      eventCategory
      eventCategoryOptional
      startDate
      finishDate
      memo
      createdAt
      updatedAt
      authorID
      varieties
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listCultivationEvents = /* GraphQL */ `
  query ListCultivationEvents(
    $filter: ModelCultivationEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCultivationEvents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        farmID
        eventCategory
        eventCategoryOptional
        startDate
        finishDate
        memo
        createdAt
        updatedAt
        authorID
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncCultivationEvents = /* GraphQL */ `
  query SyncCultivationEvents(
    $filter: ModelCultivationEventFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncCultivationEvents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        farmID
        eventCategory
        eventCategoryOptional
        startDate
        finishDate
        memo
        createdAt
        updatedAt
        authorID
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listCultivationEventsByFarm = /* GraphQL */ `
  query ListCultivationEventsByFarm(
    $farmID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCultivationEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCultivationEventsByFarm(
      farmID: $farmID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        farmID
        eventCategory
        eventCategoryOptional
        startDate
        finishDate
        memo
        createdAt
        updatedAt
        authorID
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getMonthReport = /* GraphQL */ `
  query GetMonthReport($id: ID!) {
    getMonthReport(id: $id) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      yearMonth
      totalWorkingTime
      pesticideSprayningTime
      matingWorkTime
      harvestingTime
      fruitsThinningTime
      othersTime
      createdAt
      updatedAt
      dailyLogs {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listMonthReports = /* GraphQL */ `
  query ListMonthReports(
    $filter: ModelMonthReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMonthReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        farmID
        yearMonth
        totalWorkingTime
        pesticideSprayningTime
        matingWorkTime
        harvestingTime
        fruitsThinningTime
        othersTime
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncMonthReports = /* GraphQL */ `
  query SyncMonthReports(
    $filter: ModelMonthReportFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncMonthReports(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        farmID
        yearMonth
        totalWorkingTime
        pesticideSprayningTime
        matingWorkTime
        harvestingTime
        fruitsThinningTime
        othersTime
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listMonthReportsByFarm = /* GraphQL */ `
  query ListMonthReportsByFarm(
    $farmID: ID!
    $yearMonth: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMonthReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMonthReportsByFarm(
      farmID: $farmID
      yearMonth: $yearMonth
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        farmID
        yearMonth
        totalWorkingTime
        pesticideSprayningTime
        matingWorkTime
        harvestingTime
        fruitsThinningTime
        othersTime
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($id: ID!) {
    getMessage(id: $id) {
      id
      conversationID
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      senderID
      sender {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      content
      createdAt
      updatedAt
      isSent
      isRead
      isImportant
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conversationID
        senderID
        content
        createdAt
        updatedAt
        isSent
        isRead
        isImportant
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncMessages = /* GraphQL */ `
  query SyncMessages(
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncMessages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        conversationID
        senderID
        content
        createdAt
        updatedAt
        isSent
        isRead
        isImportant
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listMessagesByConversation = /* GraphQL */ `
  query ListMessagesByConversation(
    $conversationID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessagesByConversation(
      conversationID: $conversationID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        senderID
        content
        createdAt
        updatedAt
        isSent
        isRead
        isImportant
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listMessagesByUser = /* GraphQL */ `
  query ListMessagesByUser(
    $senderID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessagesByUser(
      senderID: $senderID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        senderID
        content
        createdAt
        updatedAt
        isSent
        isRead
        isImportant
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getConversation = /* GraphQL */ `
  query GetConversation($id: ID!) {
    getConversation(id: $id) {
      id
      users {
        nextToken
        startedAt
      }
      groups {
        nextToken
        startedAt
      }
      messages {
        nextToken
        startedAt
      }
      sendPictures {
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listConversations = /* GraphQL */ `
  query ListConversations(
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConversations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncConversations = /* GraphQL */ `
  query SyncConversations(
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncConversations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getUserConversation = /* GraphQL */ `
  query GetUserConversation($id: ID!) {
    getUserConversation(id: $id) {
      id
      userID
      user {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      conversationID
      createdAt
      updatedAt
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listUserConversations = /* GraphQL */ `
  query ListUserConversations(
    $filter: ModelUserConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserConversations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        conversationID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncUserConversations = /* GraphQL */ `
  query SyncUserConversations(
    $filter: ModelUserConversationFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncUserConversations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        userID
        conversationID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listConversationsByUser = /* GraphQL */ `
  query ListConversationsByUser(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConversationsByUser(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        conversationID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getGroupConversation = /* GraphQL */ `
  query GetGroupConversation($id: ID!) {
    getGroupConversation(id: $id) {
      id
      groupID
      group {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      conversationID
      createdAt
      updatedAt
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      isIntergroup
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listGroupConversations = /* GraphQL */ `
  query ListGroupConversations(
    $filter: ModelGroupConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGroupConversations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groupID
        conversationID
        createdAt
        updatedAt
        isIntergroup
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncGroupConversations = /* GraphQL */ `
  query SyncGroupConversations(
    $filter: ModelGroupConversationFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncGroupConversations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        groupID
        conversationID
        createdAt
        updatedAt
        isIntergroup
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listConversationsByGroup = /* GraphQL */ `
  query ListConversationsByGroup(
    $groupID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelGroupConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConversationsByGroup(
      groupID: $groupID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        groupID
        conversationID
        createdAt
        updatedAt
        isIntergroup
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const getSendPicture = /* GraphQL */ `
  query GetSendPicture($id: ID!) {
    getSendPicture(id: $id) {
      id
      conversationID
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      senderID
      sender {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      sendPhotokey
      createdAt
      updatedAt
      isSent
      isRead
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const listSendPictures = /* GraphQL */ `
  query ListSendPictures(
    $filter: ModelSendPictureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSendPictures(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        conversationID
        senderID
        sendPhotokey
        createdAt
        updatedAt
        isSent
        isRead
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const syncSendPictures = /* GraphQL */ `
  query SyncSendPictures(
    $filter: ModelSendPictureFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncSendPictures(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        conversationID
        senderID
        sendPhotokey
        createdAt
        updatedAt
        isSent
        isRead
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listSentPicturesByConversation = /* GraphQL */ `
  query ListSentPicturesByConversation(
    $conversationID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSendPictureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSentPicturesByConversation(
      conversationID: $conversationID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        senderID
        sendPhotokey
        createdAt
        updatedAt
        isSent
        isRead
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
export const listSentPicturesByUser = /* GraphQL */ `
  query ListSentPicturesByUser(
    $senderID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSendPictureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSentPicturesByUser(
      senderID: $senderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        conversationID
        senderID
        sendPhotokey
        createdAt
        updatedAt
        isSent
        isRead
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`;
